import React from 'react';
import {companyData} from '../data/mock';
import {ChevronDown} from 'lucide-react';
import {useLanguage} from '../i18n/LanguageContext';

const Hero = () => {
    const {t} = useLanguage();

    const scrollToAbout = () => {
        document.getElementById('about')?.scrollIntoView({behavior: 'smooth'});
    };

    return (
        <section className="hero-section">
            <div className="hero-background">
                <img
                    src={companyData.heroImage}
                    alt="Company workspace"
                    className="hero-image"
                />
                <div className="hero-overlay"></div>
            </div>

            <div className="hero-content">
                <h1 className="hero-title">{companyData.name}</h1>
                <p className="hero-tagline">{t('hero.tagline')}</p>
            </div>

            <div className="hero-scroll-indicator" onClick={scrollToAbout}>
                <ChevronDown className="animate-bounce"/>
            </div>
        </section>
    );
};

export default Hero;
